import { createSlice } from '@reduxjs/toolkit';

export const clientContactsSlice = createSlice({
    name: "clientContacts",
    initialState: [],
    reducers: {
        set: (state, action) => {
            state = action.payload;
            return state;
        }
    }
})

export const clientContactsActions = clientContactsSlice.actions;

export default clientContactsSlice.reducer;